// Call Centers API client (Phase 6).
import { request } from './api';

export const callCentersApi = {
    list: () => request('/call-centers'),
    create: (body) => request('/call-centers', { method: 'POST', body }),
    update: (id, body) => request(`/call-centers/${id}`, { method: 'PATCH', body }),
    remove: (id) => request(`/call-centers/${id}`, { method: 'DELETE' }),
    // Phase C.1 — couverture d'absence : {coverage_user_id: str|null}
    setCoverage: (id, coverage_user_id) =>
        request(`/call-centers/${id}/coverage`, { method: 'PATCH', body: { coverage_user_id } }),
};
